<template>
  <div class="px-4 pb-5">
    <div class="d-flex justify-center align-center flex-column">
      <h3
        style="font-weight: 500"
      >
        {{ title() }}
      </h3>
      <div class="d-flex justify-center">
        <div v-if="user && user.id" class="mr-3">
          <span
            class="small-title mr-1"
          >
            ID
          </span>
          <span
            class="small-text"
          >
            {{ user.id }}
          </span>
        </div>
        <div>
          <span
            class="small-title mr-1"
          >
            Organisation
          </span>
          <span
            class="small-text"
          >
            {{ organization.name }}
          </span>
        </div>
      </div>
    </div>
    <v-text-field
      dense
      v-model="firstName"
      label="Prénom"
      :rules="rulesFirstName"
    />
    <v-text-field
      dense
      v-model="lastName"
      label="Nom"
      :rules="rulesLastName"
    />
    <v-text-field
      dense
      v-model="email"
      label="Courriel"
      :rules="rulesEmail"
    />
    <v-autocomplete
      label="Groupes"
      v-model="groups"
      clearable
      multiple
      :items="organization.groups"
    >
      <template v-slot:item="item">
        <div>
          {{ item.item.name }}
        </div>
      </template>
      <template v-slot:selection="selection">
        <v-chip close @click:close="removeGroup(selection.index)">
          {{ selection.item.name }}
        </v-chip>
      </template>
    </v-autocomplete>
    <v-switch
      v-model="admin"
      label="Administrateur"
    />
    <div class="d-flex justify-space-between">
      <DeleteDialog
        v-if="user && user.id"
        title="Supprimer l'utilisateur"
        :entity-id="user.id"
        :entity-name="`${user.firstName} ${user.lastName}`"
        @deleted="deleteUser"
      />
      <div v-else /> <!-- For justify-space-between -->
      <v-btn
        text
        color="primary"
        @click.stop="onSave"
        :disabled="!validForm()"
      >
        Sauvegarder
      </v-btn>
    </div>
  </div>
</template>
<script>
import { validateEmail } from '@/tools/emailUtils';
import DeleteDialog from './DeleteDialog';
import { OrganizationService } from './OrganizationService';

export default {
  name: 'UserForm',
  components: { DeleteDialog },
  props: {
    user: {
      type: Object,
      default: undefined,
    },
    organization: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      groups: [],
      admin: false,
      firstName: '',
      lastName: '',
      email: '',
      rulesFirstName: [this.validName],
      rulesLastName: [this.validName],
      rulesEmail: [this.validEmail],
    };
  },
  methods: {
    title() {
      if (this.user && this.user.id) {
        return 'Paramètres utilisateur';
      }
      return "Création d'un nouvel utilisateur";
    },
    removeGroup(index) {
      this.groups.splice(index, 1);
    },
    validName(name) {
      if (!name) return false;

      return name.length >= 1;
    },
    validEmail(email) {
      if (!email) return false;

      return validateEmail(email);
    },
    validForm() {
      return this.validName(this.firstName)
        && this.validName(this.lastName)
        && this.validEmail(this.email);
    },
    buildGroupsArray() {
      if (!this.user || !this.user.groups || this.user.groups.length === 0) {
        return [];
      }

      const groups = [];

      this.user.groups.forEach(group => {
        const groupEntry = this.organization.groups.find(g => g.id === group.id);
        if (groupEntry) {
          groups.push(groupEntry);
        } else {
          console.error('No match for group ', group.id, ' in organization groups');
        }
      });

      return groups;
    },
    async onSave() {
      const user = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        groups: this.groups.map(group => group.id),
        isAdmin: this.admin,
      };
      if (!this.user) {
        await this.organizationService.createUserInOrganization(this.organization.id, user);
      } else {
        await this.organizationService.updateUserInOrganization(this.organization.id, this.user.id, user);
      }
      this.$emit('saved');
    },
    updateFields() {
      this.groups = this.buildGroupsArray();
      this.admin = this.isAdmin();
      this.firstName = this.user ? this.user.firstName : '';
      this.lastName = this.user ? this.user.lastName : '';
      this.email = this.user ? this.user.email : '';
    },
    async deleteUser() {
      await this.organizationService.deleteUserFromOrganization(this.organization.id, this.user.id);
      this.$emit('saved');
    },
    isAdmin() {
      if (!this.user) return false;
      const role = this.user.roles.find(r => r === 'NOOS_ADMIN');
      if (role) return true;
      return false;
    },
  },
  watch: {
    user() {
      this.updateFields();
    },
  },
  created() {
    this.organizationService = new OrganizationService();
    this.updateFields();
  },
};
</script>
<style scoped>
.small-title {
  font-size: 12px;
  font-weight: 500;
  color: rgba(100, 100, 100, 1);
}
.small-text {
  font-size: 10px;
  font-weight: 350;
  color: rgba(100, 100, 100, 1);
}
</style>
